export function fetchLocaleFromPath(
  pathname: string,
  allowedLocales: string[],
) {
  const locale = pathname.split('/')[1];

  if (!locale) {
    return;
  }

  // /en-US/foo/bar -> en-US (VALID)
  // /en-us/foo/bar -> en-US (VALID)
  // /foo/bar -> foo (INVALID) -> return undefined
  return matchSupportedLocale(locale, allowedLocales);
}

export function matchSupportedLocale(locale: string, allowedLocales: string[]) {
  return allowedLocales.find((l) => l.toLowerCase() === locale.toLowerCase());
}
